import React, { useEffect } from 'react'
import FormHeader from '../../components/user/includes/FormHeader'
import InviteUserForm from './components/InviteUserForm'
import { tagHotjarRecording } from '../../helpers/util'
import Spacer from '../../components/views/includes/Spacer'
import {
    AppContainer,
    MainSection,
    Section,
} from '../../components/views/includes/Wrappers'
import useAuth from '../../hooks/useAuth'
import AppRoutes from '../../routes/appRoutes'

const InviteUserPage = () => {
    const { user, impersonatedBy } = useAuth()
    const userCompany = user?.company

    // On mount
    useEffect(() => {
        tagHotjarRecording('Invite User')
    }, [])

    return (
        <AppContainer className="form" whiteBodyBackground={true}>
            <FormHeader headerTitle="New User" backLink={AppRoutes.users()} />

            <Spacer size="tiny" />

            <MainSection className="profile-options">
                <Section>
                    <InviteUserForm
                        companyName={userCompany.name}
                        impersonatedBy={impersonatedBy}
                        sapId={userCompany.sap_id}
                    />
                </Section>
            </MainSection>
        </AppContainer>
    )
}

export default InviteUserPage
